export const DocumentStatus = ['REVIEWING', 'VERIFIED', 'REJECTED', undefined] as const;

export type DocumentStatus = (typeof DocumentStatus)[number];

export type StatusMetadata = {
  label: string;
  color: 'positive' | 'negative' | 'warning' | 'primary';
};

export type DocumentStatusMetadataType = Record<
  Exclude<DocumentStatus, undefined>,
  StatusMetadata
> & {
  undefined?: Pick<StatusMetadata, 'label' | 'color'> & { color: 'warning' };
};

export const DocumentStatusMetadata: DocumentStatusMetadataType = {
  REVIEWING: { label: 'Reviewing', color: 'primary' },
  VERIFIED: { label: 'Verified', color: 'positive' },
  REJECTED: { label: 'Rejected', color: 'negative' },
  undefined: { label: 'Awaiting Upload', color: 'warning' },
};

export enum LoansFollowupFormEvents {
  AdminPageView = 'Loans Followup Form - Admin Page - Page View',
  SetTemplate = 'Loans Followup Form - Admin Page - Set Template',
  EmailStudent = 'Loans Followup Form - Admin Page - Email Student',
  EmailLoanProvider = 'Loans Followup Form - Admin Page - Email Loan Provider',
  VerifyDocument = 'Loans Followup Form - Admin Page - Verify Document',
  RejectDocument = 'Loans Followup Form - Admin Page - Reject Document',
  DeleteFile = 'Loans Followup Form - Admin Page - Delete File',
  PublicPageView = 'Loans Followup Form - Public Page - Page View',
  UploadDocument = 'Loans Followup Form - Public Page - Upload Document',
  SubmitForReview = 'Loans Followup Form - Public Page - Submit For Review',
}
